"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const qs_1 = __importDefault(require("qs"));
axios_1.default.defaults.baseURL = document.querySelector('meta[name="url"]')?.content ?? "http://localhost";
axios_1.default.interceptors.request.use((config) => {
    config.paramsSerializer = (params) => {
        return qs_1.default.stringify(params, {
            arrayFormat: "brackets",
            encode: false,
        });
    };
    return config;
});
axios_1.default.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
exports.default = axios_1.default;
